import { InjectionToken } from '@angular/core';

export const DEFAULT_VALUES = new InjectionToken('defaultValues');
